export enum formOptions {
    form = 'form',
    json = 'json',
    validationSchematron = 'validationSchematron',
    validationQuick = 'validationQuick',
    validationFull = 'validationFull',
    print = 'print',
    downloadxml = 'downloadxml',
}
